/**
 * Small relative-time helper. Returns strings like:
 *   "just now", "12m ago", "3h ago", "2 days ago", "Mar 14, 2025"
 */
export function timeAgo(iso) {
    if (!iso) return null;
    const then = new Date(iso).getTime();
    if (!Number.isFinite(then)) return null;
    const diff = Math.max(0, Date.now() - then);

    const sec = Math.floor(diff / 1000);
    if (sec < 30) return 'just now';
    if (sec < 60) return `${sec}s ago`;

    const min = Math.floor(sec / 60);
    if (min < 60) return `${min}m ago`;

    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr}h ago`;

    const day = Math.floor(hr / 24);
    if (day === 1) return 'yesterday';
    if (day < 7) return `${day} days ago`;
    if (day < 30) return `${Math.floor(day / 7)}w ago`;

    return new Date(iso).toLocaleDateString(undefined, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    });
}

/** Format a date as "Mon · Mar 14" — used for grouping rows in the list. */
export function dayLabel(iso) {
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
    });
}

/** "1h 22m" / "47m" / "—" — duration between two ISO timestamps. */
export function duration(startIso, endIso) {
    if (!startIso || !endIso) return null;
    const ms =
        new Date(endIso).getTime() - new Date(startIso).getTime();
    if (!Number.isFinite(ms) || ms < 0) return null;
    const totalMin = Math.floor(ms / 60000);
    const h = Math.floor(totalMin / 60);
    const m = totalMin % 60;
    if (h <= 0) return `${m}m`;
    return `${h}h ${String(m).padStart(2, '0')}m`;
}
